class ProgressBarController {
    constructor() {
        "ngInject";
    }

    $onInit() {
        // Set defaults
        this.height = parseInt(this.height) || 20;
        this.color = this.color || '#27ae60';
        this.bgColor = this.bgColor || '#e0e0e0';
        this.showPercentage = this.showPercentage !== false;
        this.showValues = this.showValues === true;
        this.animated = this.animated !== false;
        this.striped = this.striped === true;
    }

    getProgressPercentage() {
        const current = parseFloat(this.current) || 0;
        const total = parseFloat(this.total) || 0;
        if (total === 0) return 0;
        return Math.min(100, (current / total) * 100);
    }

    getCurrentValue() {
        return parseFloat(this.current) || 0;
    }

    getTotalValue() {
        return parseFloat(this.total) || 0;
    }

    getProgressWidth() {
        return this.getProgressPercentage() + '%';
    }

    getBarClasses() {
        let classes = 'progress-bar-fill';
        if (this.animated) {
            classes += ' progress-bar-animated';
        }
        if (this.striped) {
            classes += ' progress-bar-striped';
        }
        return classes;
    }
}

export default ProgressBarController;




// WEBPACK FOOTER //
// ./client/common/directives/progress-bar/progress-bar.controller.js